/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConduitSettingsItemNumberTagComponent } from './conduit-settings-item-number-tag.component';
import { SysqueDropdownOptionsLineModule } from '../../../../../../../../../../../shared/ui/src/lib/components/sysque-dropdown-options-line';
import { SysqueCheckBoxOptionsLineModule } from '../../../../../../../../../../../shared/ui/src/lib/components/sysque-check-box-options-line';
import { SysqueLocationOptionsLineModule } from '../../../../../../../../../../../shared/ui/src/lib/components/sysque-location-options-line';

@NgModule({
  declarations: [ConduitSettingsItemNumberTagComponent],
  imports: [
    CommonModule,
    SysqueDropdownOptionsLineModule,
    SysqueCheckBoxOptionsLineModule,
    SysqueLocationOptionsLineModule,
  ],
  exports: [ConduitSettingsItemNumberTagComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ConduitSettingsItemNumberTagModule {}
